import React from "react";
import { useIDEContext } from "../contexts/IDEContext";
import ToggleSwitch from "./ToggleSwitch";

const QuickModeSwitch = () => {
  const { quickMode, setQuickMode } = useIDEContext();

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      Quick Mode:
      <ToggleSwitch checked={quickMode} onChange={(next) => setQuickMode(next)} />
    </div>
  );
};

export default QuickModeSwitch;
